module.exports = __webpack_public_path__ + "static/img/img_15.3049cd7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hs_seniors_gallery/img_15.jpg
// module id = TH27
// module chunks = 0